'use client'

import { AppStoreDownloadButton } from '@/components/app-store-download-button'
import { Motion } from '@/components/motion'
import { PhoneScreen } from '@/components/phone-screen'
import { PlayStoreDownloadButton } from '@/components/play-store-download-button'
import { T } from '@/components/t'
import { HomePeers } from '@/features/home/home-peers'
import { homeSizeStyles } from '@/features/home/utils/home-size'
import { cn } from '@/utils/styles/cn'

export function HomeHero({ customDeeplink }: { customDeeplink?: string }) {
    return (
        <div
            className={cn(
                'flex md:flex-row flex-col-reverse items-center md:pt-6 lg:pt-8 md:px-8 px-4 max-w-[100vw]',
                homeSizeStyles
            )}
        >
            <div
                className="flex flex-row items-end lg:w-fit relative md:right-[-20px] right-0 md:w-[50%] w-[100%] md:mt-0 mt-12
                    pl-[15%] md:pl-0"
            >
                <Motion
                    y={60}
                    baseDelay={0.08}
                    duration={0.8}
                    yStiffness={130}
                    ease="easeOut"
                    className=""
                >
                    <PhoneScreen
                        getContentSrc={(language) => `/_images/screens/restaurant-${language}.webp`}
                        className="scale-[1.08] sm:scale-[1]"
                    />
                </Motion>

                <Motion
                    baseDelay={0.24}
                    y={80}
                    duration={0.6}
                    yStiffness={140}
                    ease="easeIn"
                    className="relative z-[-1] mb-[10%] right-[20%]"
                >
                    <PhoneScreen
                        getContentSrc={(locale) => `/_images/screens/map-${locale}.webp`}
                        className="scale-[1.2] sm:scale-[1.09]"
                    />
                </Motion>
            </div>

            <div
                className="flex flex-col items-center md:items-start px-0 p-2 md:p-6 md:pt-6 pt-2 md:pl-0 md:max-w-[360px]
                    sm:max-w-[70%] max-w-[100%] lg:max-w-[100%] lg:w-fit"
            >
                <Motion
                    baseDelay={0.18}
                    y={50}
                    className="mb-4 w-full justify-center md:justify-start flex relative"
                >
                    <HomePeers />
                </Motion>

                <Motion baseDelay={0.25} y={55}>
                    <h1 className="text-[36px] md:text-[40px] lg:text-[44px] xl:text-[48px] font-bold mb-4 md:text-start text-center">
                        <T span t={'home.hero.title.firstLine'} className="whitespace-nowrap" />
                        <br />
                        <T span t={'home.hero.title.secondLine'} className="whitespace-nowrap" />
                    </h1>
                </Motion>

                <Motion baseDelay={0.45} y={70} className="mb-6">
                    <T
                        p
                        t={'home.hero.description'}
                        className="font-normal text-black/70 max-w-[500px] md:text-start text-center text-[14px] md:text-[16px]"
                    />
                </Motion>

                <div className="flex flex-row gap-2 mb-4 md:mb-0">
                    <Motion baseDelay={0.8} y={40}>
                        <AppStoreDownloadButton customDeeplink={customDeeplink} />
                    </Motion>

                    <Motion baseDelay={1} y={40}>
                        <PlayStoreDownloadButton customDeeplink={customDeeplink} />
                    </Motion>
                </div>
            </div>
        </div>
    )
}
